import { ChipVariant } from "Components/atoms/chip"

export enum EmploymentStatuses {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    TERMINATED = 'TERMINATED'
}

// Statuses are DB rows, so anything seeded later falls through to the default.
export const EMPLOYEE_STATUS_VARIANT: Record<string, ChipVariant> = {
    [EmploymentStatuses.ACTIVE]: 'success',
    [EmploymentStatuses.INACTIVE]: 'secondary',
    [EmploymentStatuses.TERMINATED]: 'danger',
}
